import React, { useState } from "react";
import ICelebrateArt from "../../../assets/svg/ICelebrateArt";

export const ICelebrateModal = ({ handleClose }) => {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40 backdrop-blur-xs">
      <div className="bg-white rounded-lg max-w-md w-full mx-4 p-6 relative overflow-y-auto max-h-[90vh]">
        <div className="flex flex-col items-center space-y-8">
          <ICelebrateArt className="w-full max-w-xs" />
          <div className="text-center">
            <h2 className="text-lg font-semibold">
              What are you looking for right now? Post it on iCelebrate!
            </h2>
            <p className="text-sm mt-2">
              Post anything you need for an upcoming event. Merchants may send
              offers specifically designed to your event.
            </p>
          </div>
        </div>
        <div className="mt-4 flex justify-center">
          <button
            onClick={handleClose}
            className="bg-primary-500 text-white py-3 px-8 rounded-xl font-medium text-sm"
          >
            Got it!
          </button>
        </div>
      </div>
    </div>
  );
};
